import { render, staticRenderFns } from "./PosApp.vue?vue&type=template&id=1dd68a90&"
import script from "./PosApp.vue?vue&type=script&lang=js&"
export * from "./PosApp.vue?vue&type=script&lang=js&"
import style0 from "./PosApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports